import PropTypes from 'prop-types';
import Panel from './Panel.js';
import Schedules from './Schedules.js';

const propTypes = {
  id: PropTypes.number,
  sheetId: PropTypes.string,
  name: PropTypes.string,
  period: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  panels: PropTypes.shape({
    items: PropTypes.objectOf(
      PropTypes.arrayOf(PropTypes.shape(Panel.propTypes))
    ),
    sortedPanelKeys: PropTypes.arrayOf(PropTypes.string),
  }),
  schedules: PropTypes.shape(Schedules.propTypes),
  status: PropTypes.string,
};

class SpreadsheetReportConfigs {
  static propTypes = propTypes;
}

export default SpreadsheetReportConfigs;
